import { Header } from '@components/layout';
import { Dashboard } from '@features/dashboard';
import { Box } from '@mui/material';

const HEADER_HEIGHT = 50;

export const HomePage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: `${HEADER_HEIGHT}px`,
          backgroundColor: 'background.default',
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        }}
      >
        <Dashboard />
      </Box>
    </Box>
  );
};
